import * as React from 'react';
import { styled } from '@mui/material/styles';
import {
  DataGrid,
  Toolbar,
  ToolbarButton,
  ColumnsPanelTrigger,
  FilterPanelTrigger,
  // ExportCsv,
  // ExportPrint,
  QuickFilter,
  QuickFilterControl,
  QuickFilterClear,
  QuickFilterTrigger,
  GridSlotProps,
  GridRowsProp,
  GridRowModesModel,
  GridRowModes,
  GridRowId,
  GridEventListener,
  GridRowEditStopReasons,
  GridRowModel,
  GridActionsCellItem,
  GridColDef,
  GridOverlay,
  GridGetRowsParams,
  GridGetRowsResponse,
  GridDataSourceCacheDefault,
  GridGetRowsError,
  
  GridUpdateRowError,
  GRID_ROOT_GROUP_ID,
  useGridApiContext,
  useGridApiRef,
} from '@mui/x-data-grid';
// import { randomArrayItem, useMockServer, randomBoolean, randomCreatedDate, randomEmail, randomId, randomPhoneNumber, randomTraderName } from '@mui/x-data-grid-generator';
import Tooltip from '@mui/material/Tooltip';
import Badge from '@mui/material/Badge';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import FilterListIcon from '@mui/icons-material/FilterList';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import CancelIcon from '@mui/icons-material/Cancel';
import SearchIcon from '@mui/icons-material/Search';
import Typography from '@mui/material/Typography';
import { AlertTitle, Box, Button, Checkbox, ClickAwayListener, Collapse, Grid, IconButton, Paper, Popper, TableRow, TableCell, TableBody, Table, TableContainer } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import axios from 'axios';
// import { IMaskInput } from 'react-imask';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AdminDialog from './Common/Dialog';
import ClearIcon from '@mui/icons-material/Clear';
import { toast, ToastContainer } from 'react-toastify';
import DownloadIcon from '@mui/icons-material/Download';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import VisibilityIcon from '@mui/icons-material/Visibility';
import BlockIcon from '@mui/icons-material/Block';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import RemoveDoneIcon from '@mui/icons-material/RemoveDone';
import ConfirmationDialog from '../Common/ConfirmationDialog';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

type OwnerState = {
  expanded: boolean;
};

const StyledQuickFilter = styled(QuickFilter)({
  display: 'grid',
  alignItems: 'center',
});

const StyledToolbarButton = styled(ToolbarButton)<{ ownerState: OwnerState }>(
  ({ theme, ownerState }) => ({
    gridArea: '1 / 1',
    width: 'min-content',
    height: 'min-content',
    zIndex: 1,
    opacity: ownerState.expanded ? 0 : 1,
    pointerEvents: ownerState.expanded ? 'none' : 'auto',
    transition: theme.transitions.create(['opacity']),
  }),
);

const StyledTextField = styled(TextField)<{
  ownerState: OwnerState;
}>(({ theme, ownerState }) => ({
  gridArea: '1 / 1',
  overflowX: 'clip',
  width: ownerState.expanded ? 260 : 'var(--trigger-width)',
  opacity: ownerState.expanded ? 1 : 0,
  transition: theme.transitions.create(['width', 'opacity']),
  marginTop: 1
}));

const roles = ['Administrator', 'Executive', 'Sales Representative'];
const initialRows: GridRowsProp = [];

declare module '@mui/x-data-grid' {
  interface ToolbarPropsOverrides {
    setRows: (newRows: (oldRows: GridRowsProp) => GridRowsProp) => void;
    setRowModesModel: (
      newModel: (oldModel: GridRowModesModel) => GridRowModesModel,
    ) => void;
  }
}

function CustomToolbar(props: GridSlotProps['toolbar']) {
  const apiRef = useGridApiContext();
  const {setRows, setRowModesModel} = props;
  const [exportMenuOpen, setExportMenuOpen] = React.useState(false);
  const exportMenuTriggerRef = React.useRef<HTMLButtonElement>(null);

  const handleClick = () => {
    // const id = randomId();
    // setRows((oldRows) => [
    //   ...oldRows,
    //   { id, name: '', age: '', role: '', isNew: true },
    // ]);
    // setRowModesModel((oldModel) => ({
    //   ...oldModel,
    //   [id]: { mode: GridRowModes.Edit, fieldToFocus: 'name' },
    // }));
  };

  // const handleUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     setOpenDialog(true);
  //     const reader = new FileReader();
  //     reader.onload = (event) => {
  //       const text = event.target?.result as string;
  //       let fileLines = text.split(/\r?\n/);
  //       const lines: any = fileLines.map((line, index) => {
  //         if (index >= 1) {
  //           const lineArray = line.split('\t').map((item) => item.trim());
  //           return lineArray[0] + '\t' + lineArray[2] + '\t' + lineArray[1];
  //         }
  //       });
  //       // Remove the header line and join the rest as a string
  //       setFileContent(lines.slice(1, lines.length - 1).join('\n'));
  //     };
  //     reader.readAsText(file);
  //   }
  // };

  // const handleRemoveUser = (index: number) => {
  //   const newFileContent = fileContent.split('\n').filter((line, i) => i !== index).join('\n');
  //   setFileContent(newFileContent);
  // };

  // const completeProcess = () => {
  //   setProcessing(true);
  //   setTimeout(() => {
  //     setDisabled(false);
  //   }, 10000);
  // }

  return (
    <React.Fragment>
      <ToastContainer position='top-center'/>
      {/* <Toolbar>
        <Typography fontWeight="medium" sx={{ flex: 1, mx: 1, fontWeight: 'bold' }}>Users</Typography>
        <Link href="/admin/users/add" sx={{ textDecoration: 'none', padding: 5 }}>Download User Template</Link>
      </Toolbar> */}
      
      <Toolbar>
        <Typography fontWeight="medium" sx={{ flex: 1, mx: 1, fontWeight: 'bold' }}>Users</Typography>
        {/* <Tooltip title="Upload user file">
          <IconButton
            component="label"
            role={undefined}
            tabIndex={-1}
            style={{ textTransform: 'none', color: 'white'}}
          >
            <CloudUploadIcon fontSize="small" />
            <VisuallyHiddenInput
              type="file"
              accept=".csv, .xlsx"
              onChange={(event) => console.log(event.target.files)}
              multiple
            />
          </IconButton>
        </Tooltip> */}
        {/*<Tooltip title="Add new user">
          <ToolbarButton 
            ref={newPanelTriggerRef} 
            aria-controls="new-user-panel" 
            aria-haspopup="true" 
            aria-expanded={newPanelOpen ? 'true' : undefined} 
            onClick={() => setNewPanelOpen((prev) => !prev)}
          >
            <AddIcon fontSize="small" />
          </ToolbarButton>
        </Tooltip> */}

        {/* Adding the popup window for creating a new user */}
        {/* <Popper
          open={newPanelOpen}
          anchorEl={newPanelTriggerRef.current}
          placement="bottom-end"
          id="new-panel"
          onKeyDown={handleKeyDown}
        >
          <ClickAwayListener onClickAway={handlePanelClose}>
            <Paper
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                width: 300,
                p: 2,
              }}
              elevation={8}
            >
              <Typography fontWeight="bold" sx={{textAlign: 'center'}}>Add new user</Typography>
              <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }} onSubmit={handleCreateUser}>
                <Stack spacing={2}>
                  <TextField
                    label="Name"
                    name="name"
                    size="small"
                    autoFocus
                    fullWidth
                    required
                  />
                  <TextField
                    label="Phone"
                    type="number"
                    name="phone"
                    size="small"
                    fullWidth
                    required
                    onChange={(event) => setPhone(event.target.value as string)}
                  />
                  <TextField
                    label="Email"
                    type="email"
                    name="email"
                    size="small"
                    fullWidth
                    required
                    onChange={(event) => setEmail(event.target.value as string)}
                  />
                  <TextField
                    select
                    label="Role"
                    name="role"
                    size="small"
                    fullWidth
                    required
                    value={role}
                    onChange={(event) => setRole(event.target.value as string)}
                  >
                    {roles.map((role) => (
                      <MenuItem key={role} value={role}>
                        {role}
                      </MenuItem>
                    ))}
                  </TextField>
                  <Button type="submit" variant="contained" fullWidth style={{textTransform: 'none'}}>Save</Button>
                  <Button type="reset" fullWidth style={{textTransform: 'none'}} onClick={handlePanelClose}>Cancel</Button>
                </Stack>
              </Box>
            </Paper>
          </ClickAwayListener>
        </Popper> */}

        {/* <Tooltip title="Massive creation of users">
          <ToolbarButton  
            render={
              <IconButton component="label">
                <CloudUploadIcon fontSize="small" />
                <VisuallyHiddenInput
                  type="file"
                  accept=".xls,.xlsx,.csv"
                  onChange={(event) => handleUpload(event)}
                />
              </IconButton>
            }
          />

        </Tooltip> */}
        <Tooltip title="Add single user">
          <ToolbarButton onClick={handleClick}>
            <AddIcon fontSize="small" />
          </ToolbarButton>
        </Tooltip>
        <Tooltip title="Refresh data">
          <ToolbarButton onClick={() => apiRef.current.dataSource.fetchRows(GRID_ROOT_GROUP_ID, { skipCache: true })}>
            <RefreshIcon fontSize="small" />
          </ToolbarButton>
        </Tooltip>
        <Tooltip title="Export">
            <ToolbarButton onClick={() => window.location.href = '/admin/users/export/?entity_id=' + localStorage.getItem('entity_id')}>
                <DownloadIcon fontSize="small" />
            </ToolbarButton>
        </Tooltip>

        <Divider orientation="vertical" variant="middle" flexItem sx={{ mx: 0.5 }} />
        <Tooltip title="Columns">
          <ColumnsPanelTrigger
            render={
              <ToolbarButton>
                <ViewColumnIcon fontSize="small" />
              </ToolbarButton>
            }
          />
        </Tooltip>

        <Tooltip title="Filters">
          <FilterPanelTrigger
            render={(props, state) => (
              <ToolbarButton {...props} color="default">
                <Badge badgeContent={state.filterCount} color="primary" variant="dot">
                  <FilterListIcon fontSize="small" />
                </Badge>
              </ToolbarButton>
            )}
          />
        </Tooltip>

        <Divider orientation="vertical" variant="middle" flexItem sx={{ mx: 0.5 }} />

        {/* <Tooltip title="Export">
          <ToolbarButton
            ref={exportMenuTriggerRef}
            id="export-menu-trigger"
            aria-controls="export-menu"
            aria-haspopup="true"
            aria-expanded={exportMenuOpen ? 'true' : undefined}
            onClick={() => setExportMenuOpen(true)}
          >
            <FileDownloadIcon fontSize="small" />
          </ToolbarButton>
        </Tooltip>

        <Menu
          id="export-menu"
          anchorEl={exportMenuTriggerRef.current}
          open={exportMenuOpen}
          onClose={() => setExportMenuOpen(false)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          slotProps={{
            list: {
              'aria-labelledby': 'export-menu-trigger',
            },
          }}
        >
          <ExportPrint render={<MenuItem />} onClick={() => setExportMenuOpen(false)}>
            Print
          </ExportPrint>
          <ExportCsv render={<MenuItem />} onClick={() => setExportMenuOpen(false)}>
            Download as CSV
          </ExportCsv>
        </Menu> */}

        <StyledQuickFilter>
          <QuickFilterTrigger
            render={(triggerProps, state) => (
              <Tooltip title="Search" enterDelay={0}>
                <StyledToolbarButton
                  {...triggerProps}
                  ownerState={{ expanded: state.expanded }}
                  color="default"
                  aria-disabled={state.expanded}
                >
                  <SearchIcon fontSize="small" />
                </StyledToolbarButton>
              </Tooltip>
            )}
          />
          <QuickFilterControl
            render={({ ref, ...controlProps }, state) => (
              <StyledTextField
                {...controlProps}
                ownerState={{ expanded: state.expanded }}
                inputRef={ref}
                aria-label="Search"
                placeholder="Search..."
                label="Press Enter to Search"
                size="small"
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    ),
                    endAdornment: state.value ? (
                      <InputAdornment position="end">
                        <QuickFilterClear
                          edge="end"
                          size="small"
                          aria-label="Clear search"
                          material={{ sx: { marginRight: -0.75 } }}
                        >
                          <CancelIcon fontSize="small" />
                        </QuickFilterClear>
                      </InputAdornment>
                    ) : null,
                    ...controlProps.slotProps?.input,
                  },
                  ...controlProps.slotProps,
                }}
                onKeyDownCapture={async (event) => {
                  if (event.key === 'Enter') {
                    const response = await fetch(`/admin/get-users/?search=${(event.target as HTMLInputElement).value}&entity_id=${localStorage.getItem('entity_id')}`, {
                        method: 'GET',
                    });
                    const data = await response.json();
                    apiRef.current.setRows(data.users);
                    apiRef.current.setRowCount(data.totalCount);
                  }
                }}
              />
            )}
          />
        </StyledQuickFilter>
      </Toolbar>
      {/* <Toolbar>
        <Tooltip title="Upload file for deactivating users" placement="bottom">
          <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            startIcon={<CloudUploadIcon />}
            style={{textTransform: 'none', display: 'flex', alignItems: 'center', gap: 1}}
          >
            Upload users file
            <VisuallyHiddenInput
              type="file"
              accept=".csv, .xlsx"
              onChange={(event) => handleUpload(event)}
            />
          </Button>
        </Tooltip>
      </Toolbar> */}
      {/* <AdminDialog open={openDialog} onClose={() => setOpenDialog(false)} title="Upload users file" children={
        <TableContainer component={Paper} sx={{width: '100%', margin: 'auto', maxWidth: '90%', borderRadius: '10px', boxShadow: '0 0 2px #fff'}}>
          <Table sx={{width: '100%'}} size="small">
            <caption>A basic table example with a caption</caption>
            <TableBody>
              {fileContent.split('\n').map((line, index) => (
                <TableRow key={index}>
                  <TableCell style={{alignItems: 'middle', textAlign: 'center', width: '1%'}}>
                    <Tooltip title="Remove user from the list">
                      <IconButton size="small" onClick={() => handleRemoveUser(index)}>
                        <ClearIcon fontSize="small"/>
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                  <TableCell style={{fontWeight: 'bold', fontSize: '16px'}}>
                    {line.split('\t')[0]}
                    <br/>
                    <span style={{fontSize: '12px'}}>
                      <pre style={{display: 'inline', color: '#42a5f5', fontWeight: 'bold'}}>e-mail: </pre>{line.split('\t')[1]}
                    </span>
                    <br/>
                    <span style={{fontSize: '12px'}}>
                      <pre style={{display: 'inline', color: '#42a5f5', fontWeight: 'bold'}}>Company: </pre>{line.split('\t')[2]}
                    </span>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      } /> */}
    </React.Fragment>
  );
}

// interface MaskProps {
//   onChange: (event: { target: { name: string; value: string } }) => void;
//   name: string;
// }

// const EmailMask = React.forwardRef<HTMLInputElement, MaskProps>(
//   function EmailMask(props, ref) {
//     const { onChange, ...other } = props;
//     return (
//       <IMaskInput
//         {...other}
//         mask="#@#.#"
//         definitions={{
//           '#': /[a-z0-9!#$%&'*+/=?^_`{|}~-]/,
//         }}
//         inputRef={ref}
//         onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
//         overwrite
//       />
//     );
//   },
// );

// const PhoneMask = React.forwardRef<HTMLInputElement, MaskProps>(
//   function PhoneMask(props, ref) {
//     const { onChange, ...other } = props;
//     return (
//       <IMaskInput
//         {...other}
//         mask="(#00) 000-0000"
//         definitions={{
//           '#': /[1-9]/,
//         }}
//         inputRef={ref}
//         onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
//         overwrite
//       />
//     );
//   },
// );

function CustomNoRowsOverlay() {
  return (
    <GridOverlay>
      <Typography variant="body2" color="textSecondary">
        No users found. Please adjust your filters or add new data.
      </Typography>
    </GridOverlay>
  );
}

interface GridDataSource {
  /**
   * This method is called when the grid needs to fetch rows.
   * @param {GridGetRowsParams} params The parameters required to fetch the rows.
   * @returns {Promise<GridGetRowsResponse>} A promise that resolves to the data of
   * type [GridGetRowsResponse].
   */
  getRows(params: GridGetRowsParams): Promise<GridGetRowsResponse>;
}


export default function Users(props: { loggedInUser: any }) {
  const apiRef = useGridApiRef();
  const [selectedUserId, setSelectedUserId] = React.useState<GridRowId | null>(null);
  const [confirmationDialogAction, setConfirmationDialogAction] = React.useState('');
  const [confirmationDialogMessage, setConfirmationDialogMessage] = React.useState('');
  const [openConfirmationDialog, setOpenConfirmationDialog] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [open, setOpen] = React.useState(true);
  const [rows, setRows] = React.useState(initialRows);
  const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>({});
  const [totalCount, setTotalCount] = React.useState(0);
  const [user, setUser] = React.useState<{name: string, id: number} | null>(null);
  const [values, setValues] = React.useState({
    textmask: '',
  });
  const { loggedInUser } = props;
  // const handleMaskChange = (event: any) => {
  //   setValues({
  //     ...values,
  //     [event.target.name]: event.target.value,
  //   });
  // };

  const handleRowEditStop: GridEventListener<'rowEditStop'> = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleDeleteClick = (id: GridRowId) => () => {
    setConfirmationDialogAction('delete');
    setConfirmationDialogMessage('Are you sure you want to delete this user? This action cannot be undone.');
    setSelectedUserId(id);
    setOpenConfirmationDialog(true);
  };

  const deleteUser = async () => {
    const csrfToken = await axios.get('/csrf/');
    axios.post(
      `/admin/user/delete/${selectedUserId}/`, 
      { user: selectedUserId },
      {
        headers: {
          'X-CSRFToken': csrfToken.data.csrfToken,
          'Content-Type': 'application/json',
        },
      },
    ).then((response) => {
      setTimeout(() => {
        toast.success(response?.data?.message, {position: 'top-center'});
        setOpenConfirmationDialog(false);
        setRows(rows.filter((row) => row.id !== selectedUserId));
      }, 100);
    }).catch((error) => {
      setTimeout(() => {
        toast.error(error.response?.data?.message, {position: 'top-center'});
      }, 100);
      setOpenConfirmationDialog(false);
    });
  }
  const handleActivateUser = async (row: GridRowModel, id: GridRowId) => {
    const csrfToken = await axios.get('/csrf/');
    axios.post(
      `/admin/user/activate/${id}/`, 
      { user: id },
      {
        headers: {
          'X-CSRFToken': csrfToken.data.csrfToken,
          'Content-Type': 'application/json',
        },
      },
    )
    .then((response) => {
      setTimeout(() => {
        toast.success('User activated successfully', {position: 'top-center'});
      }, 100);
      setRows(rows.map((row) => (row.id === id ? { ...row, active_ind: 1 } : row)));
    })
    .catch((error) => {
      setTimeout(() => {
        toast.error(error.response?.data?.message, {position: 'top-center'});
      }, 100);
    });
  }

  const handleDisableUser = async (id: GridRowId) => {
    setSelectedUserId(id);
    setOpenConfirmationDialog(true);
    setConfirmationDialogAction('disable');
    setConfirmationDialogMessage('Are you sure you want to deactivate this user? This action cannot be undone and the user will be logged out immediately.');
  };

  const disableUser = async () => {
    const csrfToken = await axios.get('/csrf/');
    axios.post(
      `/admin/user/deactivate/${selectedUserId}/`, 
      { user: selectedUserId },
      {
        headers: {
          'X-CSRFToken': csrfToken.data.csrfToken,
          'Content-Type': 'application/json',
        },
      },
    ).then((response) => {
      setTimeout(() => {
        toast.success(response?.data?.message, {position: 'top-center'});
        setOpenConfirmationDialog(false);
        if (loggedInUser.id === selectedUserId) {
          window.location.href = '/login';
        } else {
          setRows(rows.map((row) => (row.id === selectedUserId ? { ...row, active_ind: 0 } : row)));
        }
      }, 100);
    }).catch((error) => {
      setTimeout(() => {
        toast.error(error.response?.data?.message, {position: 'top-center'});
      }, 100);
      setOpenConfirmationDialog(false);
    });
  }

  const handleCancelClick = (id: GridRowId) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (editedRow!.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const processRowUpdate = async (newRow: GridRowModel) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    const csrfToken = await axios.get('/csrf/');
    axios.post(
      `/admin/user/${newRow.id}/`,
      { 
        name: newRow.user_nm, 
        phone: newRow.phone, 
        username: newRow.username, 
        role: newRow.role,
      },
      {
        headers: {
          'X-CSRFToken': csrfToken.data.csrfToken,
          'Content-Type': 'application/json',
        },
      },
    ).then((response) => {
      setTimeout(() => {
        toast.success(response.data.message, {position: 'top-center'});
      }, 100);
    }).catch((error) => {
      setTimeout(() => {
        toast.error(error.response?.data?.message, {position: 'top-center'});
      }, 100);
    });
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel: GridRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handleSaveClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const columns: GridColDef[] = [

    {
      field: 'id', 
      type: 'number', 
      headerName: 'ID', 
      renderHeader: (params) => {
        return <span style={{ fontWeight: 'bold' }}>{params.colDef.headerName as string}</span>;
      },
      filterable: false, 
      width: 100, 
      editable: false, 
      align: 'center', 
      headerAlign: 'center',
      hideable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <span>{params.value.toString().replace(',', '')}</span>;
      },
    },
    {field: 'name', type: 'string', headerName: 'Name', width: 220, editable: true, align: 'center', headerAlign: 'center',
      renderHeader: (params) => {
        return <span style={{ fontWeight: 'bold' }}>{params.colDef.headerName as string}</span>;
      },
      renderEditCell: (params) => (
        <React.Fragment>
          {/* <FormControl variant="standard"> */}
            <TextField
              variant="standard"
              size="small"
              fullWidth
              value={params.value}
              onChange={(e) => {
                  // Update the cell value in the DataGrid's internal state
                  params.api.setEditCellValue({ id: params.id, field: params.field, value: e.target.value });
              }}
            />
          {/* </FormControl> */}
        </React.Fragment>
    ),
    },
    {field: 'phone', headerName: 'Phone', type: 'string', width: 120, align: 'center', headerAlign: 'center', editable: true,
      renderHeader: (params) => {
        return <span style={{ fontWeight: 'bold' }}>{params.colDef.headerName as string}</span>;
      },
      renderEditCell: (params) => (
        <React.Fragment>
          {/* <FormControl variant="standard"> */}
            <TextField
              variant="standard"
              size="small"
              fullWidth
              value={params.value}
              onChange={(e) => {
                // Update the cell value in the DataGrid's internal state
                params.api.setEditCellValue({ id: params.id, field: params.field, value: e.target.value });
              }}
            />
          {/* </FormControl> */}
        </React.Fragment>
      ),
    },
    {field: 'email', headerName: 'Email', type: 'string', width: 300, align: 'center', headerAlign: 'center', editable: true,
      renderHeader: (params) => {
        return <span style={{ fontWeight: 'bold' }}>{params.colDef.headerName as string}</span>;
      },
      renderEditCell: (params) => (
        <React.Fragment>
          {/* <FormControl variant="standard"> */}
            <TextField
              variant="standard"
              size="small"
              fullWidth
              value={params.value}
              onChange={(e) => {
                // Update the cell value in the DataGrid's internal state
                params.api.setEditCellValue({ id: params.id, field: params.field, value: e.target.value });
              }}
            />
          {/* </FormControl> */}
        </React.Fragment>
      ),
    },
    {field: 'role', headerName: 'Role', type: 'string', width: 250, align: 'center', headerAlign: 'center', editable: true,
      renderEditCell: (params) => {
        return <select name="role" value={params.value} onChange={(event) => params.api.setEditCellValue({ id: params.id, field: params.field, value: event.target.value })}>
          {roles.map((role) => (
            <option key={role} value={role}>{role}</option>
          ))}
        </select>
      },
      renderHeader: (params) => {
        return <span style={{ fontWeight: 'bold' }}>{params.colDef.headerName as string}</span>;
      },
    },
    {field: 'active_ind', headerName: 'Active', type: 'boolean', width: 100, editable: true, align: 'center', headerAlign: 'center',
      renderHeader: (params) => {
        return <span style={{ fontWeight: 'bold' }}>{params.colDef.headerName as string}</span>;
      },
      renderCell: (params) => {
        return (
          <Tooltip title={params.value ? 'Inactive' : 'Active'}>
            {params.value ? <DoneAllIcon fontSize="small" color="success" /> : <RemoveDoneIcon fontSize="small" color="error" />}
          </Tooltip>
        );
      },
    },
    {field: 'actions', type: 'actions' as const, disableColumnMenu: true, headerName: 'Actions', hideable: false, width: 200, cellClassName: 'actions',
      renderHeader: (params) => {
        return <span style={{ fontWeight: 'bold' }}>{params.colDef.headerName as string}</span>;
      },
      getActions: ({ row, id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        const user = {name: row.name, id: row.id, active_ind: row.active_ind};
        
        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              onClick={handleSaveClick(id)}
              label="Save"
              material={{
                sx: {
                  color: 'primary.main',
                },
              }}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<Tooltip title="Edit"><EditIcon /></Tooltip>}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            title="View"
            icon={<Tooltip title="View"><VisibilityIcon /></Tooltip>}
            label="View"
            onClick={() => {
              setOpenDialog(true);
              setUser({ name: user.name, id: user.id });
            }}
            color="inherit"
          />,
          <GridActionsCellItem
            title="Delete"
            icon={<Tooltip title="Delete"><DeleteIcon /></Tooltip>}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            title={user.active_ind ? "Disable" : "Activate"}
            icon={
              user.active_ind ? (
                <Tooltip title="Disable">
                  <BlockIcon />
                </Tooltip>
              ) : (
                <Tooltip title="Activate">
                  <PanoramaFishEyeIcon />
                </Tooltip>
              )
            }
            label={user.active_ind ? "Disable" : "Activate"}
            onClick={() => user.active_ind ? handleDisableUser(id) : handleActivateUser(row, id)}
            color="inherit"
          />
        ];
      },
    },
  ];
  

  // const handleMaskChange = (event: any) => {
  //   setValues({
  //     ...values,
  //     [event.target.name]: event.target.value,
  //   });
  // };

  

  const changeUserStatus = async (params: GridRowModel, event: React.ChangeEvent<HTMLInputElement>) => {
    // setRows(rows.map((row) => (row.id === id ? { ...row, active } : row)));
    const csrfToken = await axios.get('/csrf/');
    axios.post(
      `/change-user-status/${params.id}/`, 
      { active: params.row.active_ind == 1 ? false : true },
      {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken.data.csrfToken,
        },
      }
    ).then((response) => {
    });
  };

  
  const usersDataSource: GridDataSource = {
    getRows: async (params: GridGetRowsParams): Promise<GridGetRowsResponse> => {
      let urlDict = {};
      const { paginationModel } = params;
  
      if (paginationModel && paginationModel.page > 0) {
        urlDict = {paginationModel: JSON.stringify(paginationModel)};
      }
      if (params.filterModel.items.length > 0) {
        urlDict = {filterModel: JSON.stringify(params.filterModel)};
      }
      if (params.sortModel.length > 0) {
        urlDict = {sortModel: JSON.stringify(params.sortModel)};
      }

      const urlParams = new URLSearchParams(urlDict);
      const urlParamsString = urlParams.size > 0
        ? `?${urlParams.toString()}&entity_id=${localStorage.getItem('entity_id')}`
        : `?entity_id=${localStorage.getItem('entity_id')}`;
      const response = await fetch(`/admin/get-users/${urlParamsString}`, {
        method: 'GET',
      });
      const data = await response.json();
      return {
        rows: data.users,
        rowCount: data.totalCount,
      };
    },
  }

  const lowTTLCache = new GridDataSourceCacheDefault({ ttl: 1000 * 10 });

  return (
    <div style={{ height: 'auto', width: '100%', display: '', justifyContent: 'center', alignItems: 'center' }}>
      <Grid container spacing={2} sx={{ width: '100%', marginTop: '0' }}>
        <Grid size={12}>
          <Stack sx={{ width: '100%' }} spacing={2}>
            <Collapse in={open}>
              <Alert severity="info" sx={{ width: '100%', textAlign: 'left' }} closeText='Close instructions' onClose={() => setOpen(false)}>
                <AlertTitle sx={{ fontWeight: 'bold' }}>Instructions for managing users</AlertTitle>
                <ol>
                  {/* <li><b>How to add user(s)</b>
                    <ol>
                      <li>
                        <b>Add a single user</b>
                        <ul>
                          <li>Add a new user by clicking the "Add single user" button (+).</li>
                          <li>Fill in the user's name, the phone number, the email address, and the role.</li>
                          <li>Click the "Save" button to save the user.</li>
                        </ul>
                      </li>
                      <li>
                        <b>Add multiple users</b>
                        <ul>
                          <li>Download the Excel template file by clicking the "Download user template file" button (<FileDownloadIcon fontSize="small" style={{ verticalAlign: 'middle' }} />).</li>
                          <li>Click the "Massive creation of users" button (<CloudUploadIcon fontSize="small" style={{ verticalAlign: 'middle' }} />).</li>
                          <li>Upload the Excel file with the users' data.</li>
                          <li>Click the "Save" button to save the users.</li>
                        </ul>
                      </li>
                    </ol>
                  </li> */}
                  <li style={{ marginTop: '10px' }}><b>How to manage a user</b>
                    <ul>
                      <li><EditIcon fontSize="small" style={{ verticalAlign: 'middle' }} /> to edit the user's data.</li>
                      <li><DeleteIcon fontSize="small" style={{ verticalAlign: 'middle' }} /> to delete the user.</li>
                      <li><BlockIcon fontSize="small" style={{ verticalAlign: 'middle' }} /> to deactivate the user.</li>
                      <li><PanoramaFishEyeIcon fontSize="small" style={{ verticalAlign: 'middle' }} /> to activate the user.</li>
                      <li><VisibilityIcon fontSize="small" style={{ verticalAlign: 'middle' }} /> to view the user's profile.</li>
                    </ul>
                  </li>
                </ol>
                {/* <br/> */}
                {/* <strong style={{ fontSize: '16px' }}>**Note: </strong><u>The phone number must be in the format of +1XXXXXXXXXX.</u> */}
              </Alert>
            </Collapse>
            <Button
              disabled={open}
              variant="outlined"
              onClick={() => {
                setOpen(true);
              }}
              style={{textTransform: 'none', border: 0}}
            >
              Re-open instructions
            </Button>
          </Stack>
        </Grid>
        <Grid size={12}>
          <DataGrid
            apiRef={apiRef}
            columns={columns}
            dataSource={usersDataSource}
            dataSourceCache={null}
            onDataSourceError={(error) => {
              if (error instanceof GridGetRowsError) {
                // `error.params` is of type `GridGetRowsParams`
                // fetch related logic, e.g set an overlay state
              }
              if (error instanceof GridUpdateRowError) {
                // `error.params` is of type `GridUpdateRowParams`
                // update related logic, e.g set a snackbar state
              }
            }}
            pagination
            initialState={{ pagination: { paginationModel: { pageSize: 10, page: 0 }, rowCount: 0 } }}
            pageSizeOptions={[5, 10, 50, 100]}
            slots={{ toolbar: CustomToolbar, noRowsOverlay: CustomNoRowsOverlay }}
            // editMode="row"
            // rowModesModel={rowModesModel}
            // onRowModesModelChange={handleRowModesModelChange}
            // onRowEditStop={handleRowEditStop}
            // processRowUpdate={processRowUpdate}
            // slotProps={{toolbar: {setRows, setRowModesModel,}}}
            showToolbar
            sx={{margin: '0 auto', width: '100%', boxShadow: '0 0 2px #fff', minHeight: 500, maxHeight: 800, borderRadius: '10px',}}            
          />
          <AdminDialog open={openDialog} manage={false} user={user} onClose={() => setOpenDialog(false)} title="User Profile" />
          <ConfirmationDialog 
            open={openConfirmationDialog} 
            onClose={() => setOpenConfirmationDialog(false)} 
            message={<span>{confirmationDialogMessage}</span>} 
            onConfirm={() => confirmationDialogAction === 'disable' ? disableUser() : deleteUser()} 
          />
        </Grid>
      </Grid>
    </div>
  );
}
 
